import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  FormText,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { registerRs } from "consts/Constants";

const schema = yup
  .object({
    name: yup.string().required(),
    website: yup.string().nullable(),
    specialty: yup.string().nullable(),
    tagline: yup.string().nullable(),
    about: yup.string().nullable(),
  })
  .required();
export default function OrganizationAboutInformationModal(props) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const [loading, setLoading] = useState(false);
  const onSubmit = (data) => {
    props.updateProfile(data, props.toggleModal, setLoading);
  };

  useEffect(() => {
    reset(props.userData);
  }, [props.userData, reset]);
  const createInputs = (
    name,
    label,
    placeHolder,
    type = "text",
    disabled = false
  ) => {
    return (
      <FormGroup>
        <label className="form-control-label" htmlFor={`input-${name}`}>
          {label}
        </label>
        <Input
          id={`input-${name}`}
          placeholder={placeHolder}
          type={type}
          disabled={loading || disabled}
          {...registerRs(name, register)}
        />
        <FormText color="danger">{errors[name]?.message}</FormText>
      </FormGroup>
    );
  };
  return (
    <Modal isOpen={props.showModal}>
      <ModalHeader>{props.title}</ModalHeader>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <ModalBody>
          {createInputs("name", "Name", "Name")}
          {createInputs("website", "Website", "Website")}
          <FormGroup>
            <label className="form-control-label" htmlFor={`input-specialty`}>
              Specialty
            </label>
            <Input
              id={`input-specialty`}
              placeholder="Specialty"
              type="text"
              disabled={loading}
              {...registerRs("specialty", register)}
            />
            <FormText>
              Tell us about your expertise- What’s your primary practice area?
            </FormText>
            <FormText color="danger">{errors.specialty?.message}</FormText>
          </FormGroup>
          {createInputs("tagline", "Tagline", "Tagline")}
          {createInputs("about", "About", "About", "textarea")}
        </ModalBody>
        {loading ? (
          <ModalFooter>
            <div
              className="d-flex ai-center jc-center"
              style={{ width: "100%" }}
            >
              <Spinner animation="border" />
            </div>
          </ModalFooter>
        ) : (
          <ModalFooter>
            <Button color="secondary" onClick={() => props.toggleModal(false)}>
              Discard
            </Button>
            <Button disabled={loading} color="primary" type="submit">
              Save
            </Button>
          </ModalFooter>
        )}
      </Form>
    </Modal>
  );
}
